<mat-toolbar color="primary">
    <mat-toolbar-row class="toolbar-row">
        <span style="color: white;">
            <img src="/assets/images/logo.svg" alt=""  id="logoToolbar" style="display:none;"/>
            <span id="labelToolbar"></span>
            <span id="labelToolbar2" class="toolbar-sub-titulo"></span>
        </span>
        <span class="example-spacer"></span>
        <!-- <mat-icon class="example-icon" aria-hidden="false" aria-label="Example user verified icon">verified_user</mat-icon> -->
    </mat-toolbar-row>
</mat-toolbar>
